// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as PentagonDefault } from '../../../assets/icons/default/shapes/pentagon.svg?react';
import { ReactComponent as PentagonSolid } from '../../../assets/icons/solid/shapes/PENTAGON.svg?react';
import { createIcons } from '../../Icon';
const PentagonIcon = /* @__PURE__ */ createIcons('Pentagon', {
    default: PentagonDefault,
    solid: PentagonSolid
});
PentagonIcon.supportedTypes = ['default', 'solid'];
PentagonIcon.category = 'shapes';
export default PentagonIcon;
